import * as React from "react";
import NavTopMenuWithLang, {
  Language as NavMenuSupportedLanguages,
} from "../modules/sunday-top-nav";
import useColorsMode from "../common/controls/mode-switcher/utils";
import { SupportedLanguages } from "../locales/interfaces";
import { useNavigationItems } from "../routes/navigation";

interface IMainAppLayoutProps {
  children: React.ReactNode;
  language: SupportedLanguages;
  onLanguageChange?: (lang: SupportedLanguages) => void;
}

// просто демонстрация
const LangMap: Record<NavMenuSupportedLanguages, SupportedLanguages> = {
  RU: "ru",
  EN: "en",
};
const ReversLangMap: Record<SupportedLanguages, NavMenuSupportedLanguages> = {
  ru: "RU",
  en: "EN",
};

const MainAppLayout: React.FunctionComponent<IMainAppLayoutProps> = ({
  language,
  children,
  onLanguageChange,
}) => {
  const [mode, setMode] = useColorsMode();
  const navItems = useNavigationItems(language);
  // const [navItems, setNavItems] = React.useState<NavigationItem[]>(
  //   GetNavigationItems(language),
  // );

  // React.useEffect(() => {
  //   setNavItems(GetNavigationItems(language));
  // }, [language]);

  return (
    <div
      className={`main-app-layout resume-site wrapper min-h-screen flex flex-col ${mode}`}
    >
      <header className="sticky top-0 z-50 shrink-0">
        <NavTopMenuWithLang
          navItems={navItems}
          initialMenuOpen={false}
          language={ReversLangMap[language]}
          onLanguageChange={(lang) => onLanguageChange?.(LangMap[lang])}
        />
      </header>
      <main className="flex-1 min-h-0 overflow-hidden">
        <div className="resume-site__app-content flex h-full min-h-0 flex-col items-center justify-start overflow-hidden">
          {children}
        </div>
      </main>
      {/* <footer className="resume-site__footer">
          <p>footer</p>
        </footer> */}
    </div>
  );
};

export default MainAppLayout;
